import { useState } from "react";

export const CustomizedContent = (props) => {
  const { x, y, width, height, index, fill, stroke, color } = props;
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const isHovered = hoveredIndex === index;
  return (
    <g
      onMouseEnter={() => setHoveredIndex(index)}
      onMouseLeave={() => setHoveredIndex(null)}
      style={{ cursor: "pointer", transition: "all 0.2s ease" }}
    >
      <rect
        x={x}
        y={y}
        width={width}
        height={height}
        style={{
          fill: isHovered ? color : fill,
          stroke,
          strokeWidth: 6,
          opacity: 0.45,
          strokeOpacity: 1,
        }}
      />
    </g>
  );
};
